export default function genererModeReglement() {
  return {
    libelle: '',
  };
}
